import GeneratePdf from './GeneratePdf'

export default GeneratePdf
